<template>
  <div>
    <header class="bg-white shadow">
      <div class="max-w-7xl mx-auto py-4 px-4 sm:px-4 lg:px-8">
        <div class="px-3 flex flex-col">
          <div class="leading-none rounded-md font-bold pb-3 flex items-center">
            <div @click="goTo('Admin Projects')">
              <v-mdi
                name="mdi-arrow-left"
                class="cursor-pointer mr-1"
              />
            </div>
            Retour à la liste des projets
          </div>
          <div class="flex gap-3">
            <a @click="goTo('Admin Project Details')"
              v-bind:class="{ 'font-bold': $route.name === 'Admin Project Details' }"
              class="py-1 rounded-md text-sm font-medium
                hover:text-primary cursor-pointer">
              Informations
            </a>
            <a @click="goTo('Admin Project Team')"
              v-bind:class="{ 'font-bold': $route.name === 'Admin Project Team' }"
              class="py-1 rounded-md text-sm font-medium
                hover:text-primary cursor-pointer">
              Membres
            </a>
            <a @click="goTo('Admin Project Content')"
              class="py-1 rounded-md text-sm font-medium hover:text-primary cursor-pointer"
              v-bind:class="{ 'font-bold': $route.name === 'Admin Project Content' }"
            >
              Dossiers et Fichiers
            </a>
          </div>
        </div>
      </div>
    </header>
    <main>
      <div class="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
        <div class="px-4 py-3 sm:px-0">
          <router-view/>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  name: 'Project',
  async mounted() {
    await this.$store.dispatch('adminProjects/fetchById', this.$route.params.projectId)
  },
  methods: {
    goTo(route) {
      this.$router.push({name: route})
    },
  },
}
</script>

<style scoped>

</style>
